export default __webpack_public_path__ + "static/media/boxtype15.cbb2add6.JPG";